import * as Yup from "yup";
import checkout from "./form";

const {
  formField: {
    taxCalculationPeriod,
    firstTime,
    supplementaryForThe,
    taxpayerName,
    taxId1,
    address,
    province,
    district,
    ward,
    homeNumber,
    phone,
    fax,
    email,
    taxAgencyName,
    taxAgencyId,
    agencyContract,
    agencyContractDate,
    documents,
    documentsDate,
    certificate,
    timeSign,
    signer,
    fullName,
  },
} = checkout;

const validation = Yup.object().shape({
  [email.name]: Yup.string().required(email.errorMsg).email(email.invalidMsg),
  [fax.name]: Yup.string().optional(),
  [documents.name]: Yup.string().optional(),
  [phone.name]: Yup.string()
    .matches(/^(?:\+?84|0)(\d{9,10})$/, phone.invalidMsg)
    .required(phone.errorMsg),
  [agencyContract.name]: Yup.string().required(agencyContract.errorMsg),
  [address.name]: Yup.string().required(address.errorMsg),
  [homeNumber.name]: Yup.string().required(homeNumber.errorMsg),
  [district.name]: Yup.string().required(district.errorMsg),
  [province.name]: Yup.string().required(province.errorMsg),
  [ward.name]: Yup.string().required(ward.errorMsg),
  [taxAgencyId.name]: Yup.string().required(taxAgencyId.errorMsg),
  [taxAgencyName.name]: Yup.string().required(taxAgencyName.errorMsg),
  [fullName.name]: Yup.string().required(fullName.errorMsg),
  [timeSign.name]: Yup.number().required(timeSign.errorMsg),
  [agencyContractDate.name]: Yup.number().required(agencyContractDate.errorMsg),
  [documentsDate.name]: Yup.number().required(documentsDate.errorMsg),
  [certificate.name]: Yup.string().required(certificate.errorMsg),
  [signer.name]: Yup.string().required(signer.errorMsg),
  [firstTime.name]: Yup.string().required(firstTime.errorMsg),
  [supplementaryForThe.name]: Yup.string()
    .matches(/^\d+$/, supplementaryForThe.invalidMsg)
    .required(supplementaryForThe.errorMsg),
  [taxCalculationPeriod.name]: Yup.number().required(taxCalculationPeriod.errorMsg),
  [taxId1.name]: Yup.string()
    .matches(/^\d{10}(?:-\d{3})?$/, taxId1.invalidMsg)
    .required(taxId1.errorMsg),
  [taxpayerName.name]: Yup.string().optional(),
});

export default validation;
